module.exports = __webpack_public_path__ + "img/iphone.png?12701bbc7c63acb4ddd38ea644454122";